<template>
  <div class="modal fade" id="modalGiveGain" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
          <h4 class="title-modal">Dar Ganho</h4>
        </div>

        <div class="modal-body filters">
          <p>
            Ação de dar ganho em empresas com contrato de várias sub-empresas,
            tirando ela do fluxo de bloqueio, habilitando o chat do suporte
            pelo painel e criando um funil.
            <strong>APENAS PARA CLIENTES BEN+ E SOLIDES</strong>
          </p>
          <div class="form-group">
            <label>Quantos funcionários no maximo?</label>
            <input v-model="dataGivaGain.totalPlanEmployee" type="text" class="form-control" name="motive"
                   v-mask="'#######'" required/>
            <span v-if="error.totalPlanEmployee" class="error-msg">{{
                error.totalPlanEmployee
              }}</span>
          </div>

          <div class="form-group">
            <label>Enviar email?</label>
            <select v-model="dataGivaGain.sendEmail">
              <option value="">Selecione</option>
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
            <span v-if="error.sendEmail" class="error-msg">{{
                error.sendEmail
              }}</span>
          </div>

          <div class="form-group owner-select">
            <label>Essa venda vai para qual mês?</label>
            <select v-model="dataGivaGain.month">
              <option value="">Selecione</option>
              <option value="1">Janeiro</option>
              <option value="2">Fevereiro</option>
              <option value="3">Março</option>
              <option value="4">Abril</option>
              <option value="5">Maio</option>
              <option value="6">Junho</option>
              <option value="7">Julho</option>
              <option value="8">Agosto</option>
              <option value="9">Setembro</option>
              <option value="10">Outubro</option>
              <option value="11">Novembro</option>
              <option value="12">Dezembro</option>
            </select>
            <span v-if="error.month" class="error-msg">{{ error.month }}</span>
          </div>

          <div class="form-group select-date">
            <label>Quando iniciar a contagem do plano?</label>
            <datepicker v-model="dataGivaGain.startAt" :language="ptBR" :format="customFormatter"
                        placeholder="dd/mm/yyyy"/>
            <i class="fa fa-calendar" aria-hidden="true"></i>
            <span v-if="error.startAt" class="error-msg">{{
                error.startAt
              }}</span>
          </div>

          <div class="form-group">
            <label>Observações</label>
            <textarea v-model="dataGivaGain.notes" class="form-control" name="description">
            </textarea>
            <span v-if="error.notes" class="error-msg">{{ error.notes }}</span>
          </div>
        </div>

        <div class="modal-footer">
          <button v-on:click="getGiveGain()" :disabled="loadingChange" v-bind:class="{ disable: loadingChange }"
                  type="submit" class="btn btn-register">
            <span v-if="!loadingChange">Salvar</span>
            <div class="loading-btn" v-else>
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </button>
          <button v-on:click="closeModal()" class="close-btn">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CHANGE_GIVEGAIN
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../msgAlertService";

import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  name: "modalGiveGain",
  props: ["dataGiveModal"],
  components: {
    datepicker,
  },

  data() {
    return {
      loadingChange: false,
      companyId: this.$route.params.idCompany,
      contextModal: this.$route.params.context,
      ptBR: ptBR,
      error: {
        totalPlanEmployee: "",
        startAt: "",
        month: "",
        notes: "",
        sendEmail: "",
      },
      dataGivaGain: {
        IsTrial: "",
        totalPlanEmployee: "",
        startAt: new Date(),
        month: "",
        notes: "",
        sendEmail: "false",
      },
    };
  },

  watch: {
    dataGiveModal: function (val) {
      this.dataGivaGain.IsTrial = val.IsTrial;
    },
  },

  methods: {
    getGiveGain() {
      this.error.totalPlanEmployee = "";
      this.error.startAt = "";
      this.error.month = "";
      this.error.notes = "";
      this.error.sendEmail = "";

      if (
        this.dataGivaGain.totalPlanEmployee &&
        this.dataGivaGain.startAt &&
        this.dataGivaGain.month &&
        this.dataGivaGain.notes &&
        this.dataGivaGain.sendEmail &&
        this.companyId
      ) {
        if (!this.loadingChange) {
          this.loadingChange = true;
          let urlModal = CHANGE_GIVEGAIN;
          urlModal += "?i=" + this.companyId;
          urlModal +=
            "&startAt=" +
            moment(this.dataGivaGain.startAt).format("YYYY-MM-DD");
          urlModal +=
            "&totalPlanEmployee=" + this.dataGivaGain.totalPlanEmployee;
          urlModal += "&notes=" + this.dataGivaGain.notes;
          urlModal += "&month=" + parseInt(this.dataGivaGain.month);
          urlModal += "&sendEmail=" + this.dataGivaGain.sendEmail;

          UTIL_SERVICE.console("DATA SEND:", this.dataGivaGain);
          REQUEST_SERVICE.requestContext("GET", urlModal, this.contextModal)
            .then((response) => {
              UTIL_SERVICE.console("RESULT CHANGE_GIVEGAIN:", response);

              this.loadingChange = false;
              $("#modalGiveGain").modal("toggle");
              ALERT_SERVICE.swal("Aviso", response.data, "success");
            })
            .catch((reason) => {
              this.loadingChange = false;
              $("#modalGiveGain").modal("toggle");
              ALERT_SERVICE.showMsgError(reason.response.data.erros);
            });
        }
      } else {
        if (!this.dataGivaGain.startAt)
          this.error.startAt = "Preencha uma data.";

        if (!this.dataGivaGain.month) this.error.month = "Preencha um mês.";

        if (!this.dataGivaGain.totalPlanEmployee)
          this.error.totalPlanEmployee = "Preencha qtd de funcionários.";

        if (!this.dataGivaGain.notes)
          this.error.notes = "Preencha o campo de texto.";

        if (!this.dataGivaGain.sendEmail)
          this.error.sendEmail = "Preencha Email.";

        if (!this.companyId) {
          this.error.startAt = "CompanyID Inválido.";
          this.error.month = "CompanyID Inválido.";
          this.error.totalPlanEmployee = "CompanyID Inválido.";
          this.error.notes = "CompanyID Inválido.";
          this.error.sendEmail = "CompanyID Inválido.";
        }
      }
    },

    closeModal() {
      $("#modalGiveGain").modal("toggle");
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
  beforeMount() {
    /* this.getGiveGain(); */
    let date = new Date();
    this.dataGivaGain.month = (date.getMonth() + 1).toString();
  },
};
</script>

<style lang="scss">
#modalGiveGain {
  .modal-body p {
    color: red;
  }

  .filters .form-group textarea {
    border-radius: 4px !important;
    outline: 0 !important;
    max-width: 100%;
  }

  .owner-select {
    width: 100%;

    select {
      border: 1px solid #999;
      border-radius: 5px;
      height: 34px;
      width: 100%;
      padding: 0 10px;
      cursor: pointer;
    }
  }

  .select-date {
    width: 100%;
    margin-top: 20px;

    p {
      font-size: 18px;
      padding-left: 1px;
    }

    .vdp-datepicker {
      display: inline-block;
      width: 100%;

      input {
        border: 1px solid #999;
        border-radius: 5px;
        height: 34px;
        width: 100%;
        padding: 0 10px;
        cursor: pointer;
      }
    }

    i {
      display: inline-block;
      position: relative;
      right: 15px;
      top: -23px;
      float: right;
      color: #111;
      cursor: pointer;
    }
  }

  .error-msg {
    font-size: 12px;
    color: #e74a4e;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalGiveGain.vue